/* eslint-disable no-nested-ternary */
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  Row,
} from 'reactstrap';
import withReactContent from 'sweetalert2-react-content';
import { PropostaVersao } from 'models/PropostaVersao';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import formatCurrency from 'utils/formatCurrency';
import { CircularProgress, TextField } from '@material-ui/core';
import { itCH } from 'date-fns/esm/locale';
import { PropostaContext } from '../..';
import { iPropostaDados } from '../Precificacao';
import Parcelas from '../Precificacao/components/Parcelas';

const MySwal = withReactContent(Swal);

interface Params {
  propostaVersao: PropostaVersao;
}

interface iTipoAprovacao {
  id: number;
  descricao: string;
  permiteInserirMultiplos: boolean;
  usaCampoCondicoes: boolean;
  maximoRegistros: number;
}

interface iLogsAprovacao {
  id: number;
  PropostaTipoAprovacao: iTipoAprovacao;
  Usuario: {
    id: number;
    nome: string;
  };
  createdAt: Date;
  descricao: string;
}

interface iDadosTipoAprovacao {
  tipoAprovacaoId: number;
}

export default function Aprovacao({ propostaVersao }: Params): JSX.Element {
  const { atualizarTelaProposta } = useContext(PropostaContext);

  const [informacaoProposta, setInformacaoProposta] =
    useState<iPropostaDados>();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [percentualAprovar, setPercentualAprovar] = useState<number>(
    propostaVersao?.desconto ?? 0,
  );
  const [valorMaoObra, setValorMaoObra] = useState<number>(
    propostaVersao?.valorMaoObraSupervisor ?? 0,
  );
  const [percentualSolicitado, setPercentualSolicitado] = useState<number>(
    propostaVersao?.desconto ?? 0,
  );

  const [aprovacaoComplemento, setAprovacaoComplemento] = useState<string>(
    propostaVersao?.aprovacaoComplemento ?? '',
  );

  const [valorMaximoUsuairo, setValorMaximoUsuario] = useState<number>(0);

  const [tipoAprovacao, setTipoAprovacao] = useState<iTipoAprovacao>(
    {} as iTipoAprovacao,
  );

  const [logsAprovacao, setLogsAprovacao] = useState<iLogsAprovacao[]>([]);

  const [aprovacoesNecessarias, setAprovacoesNecessarias] = useState<
    iDadosTipoAprovacao[]
  >([]);

  async function dadosProposta() {
    const response = await api.get(
      `/proposta-precificacao/versao/${propostaVersao.id}`,
    );
    setInformacaoProposta(response.data as iPropostaDados);
  }

  async function checkAprovacaoDescontoNecessaria(aprovar: boolean) {
    if (
      tipoAprovacao.id !== 1 ||
      !aprovacoesNecessarias.find(item => item.tipoAprovacaoId === 1)
    )
      return { aprovacao: false, salvar: true };
    if (!aprovar) return { aprovacao: false, salvar: true };

    const descontoSalvar = Number(percentualAprovar);

    if (descontoSalvar > Number(valorMaximoUsuairo ?? 0)) {
      const valor = await Swal.fire({
        title: `Nova aprovação necessária`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
            O percentual informado (${descontoSalvar}%) excede o máximo permitido (<u>menor que</u> ${valorMaximoUsuairo}%) para o perfil.
            <br /><br />O próximo grupo de aprovadores será informado, para uma nova avaliação de aprovação. Os logs da sua aprovação ficarão salvos para o próximo usuário. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#11a613',
        cancelButtonText: `Não`,
        cancelButtonColor: `#d33`,
      });
      return { aprovacao: true, salvar: valor.isConfirmed };
    }

    return { aprovacao: false, salvar: true };
  }

  console.log({
    tipoAprovacao,
  });

  async function aprovarReprovar(aprovar: boolean, motivo: string) {
    try {
      if (tipoAprovacao?.id === 3) {
        Swal.fire({
          icon: 'info',
          html: `<div>
          <p>Salvando as informações e enviando ata para lista de usuários...</p>
          <small>Se houver outras aprovações necessárias, a ata não será enviada enquanto a última aprovação não ser realizada.</small>
          </div>`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        if (aprovar)
          await api.get(
            `/ata-briefing/gerar-pdf?propostaVersaoId=${propostaVersao.id}&enviarPdf=N&retornarHtml=N`,
            {},
          );
      }
      setIsLoading(true);
      await api.put(`/proposta/versao/${propostaVersao.id}/aprovacao`, {
        aprovado: aprovar,
        motivo,
        aprovacoesNecessarias,
        tipoAprovacao: tipoAprovacao.id,
        percentualAprovado:
          tipoAprovacao.id === 4 ? valorMaoObra : percentualAprovar,
        parcelas: informacaoProposta?.parcelas ?? [],
      });
      MySwal.close();
      toast.success('Feito!', {});
    } finally {
      setIsLoading(false);
      atualizarTelaProposta(false);
    }
  }

  async function openModalReprovar() {
    let motivo = '';

    async function openModal() {
      MySwal.fire({
        title: `Deseja Reprovar as solicitações na proposta?`,
        html: `
          <strong>Informe um motivo dessa reprovação:</strong>
          <input id="swal-input1" value='${motivo}' class="swal2-input">`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, reprovar`,
        confirmButtonColor: '#11a613',
        cancelButtonText: `Não`,
        cancelButtonColor: `#d33`,
      }).then(async result => {
        const input = Swal?.getHtmlContainer()?.querySelector(
          '#swal-input1',
        ) as any;

        motivo = input.value;
        if (result.isConfirmed) {
          if (motivo.length < 5) openModal();
          else aprovarReprovar(false, motivo);
        }
      });
    }

    openModal();
  }

  async function openModalAprovar() {
    MySwal.fire({
      title: `Deseja Aprovar as solicitações na proposta?`,
      text: `Quaisquer mudanças efetuadas nos campos serão salvas e aplicadas na proposta.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, aprovar`,
      confirmButtonColor: '#11a613',
      cancelButtonText: `Não`,
      cancelButtonColor: `#d33`,
    }).then(async result => {
      if (result.isConfirmed) {
        const salvar = await checkAprovacaoDescontoNecessaria(true);

        if (salvar.salvar) {
          aprovarReprovar(true, '');
        }
      }
    });
  }

  function handleAprovarReprovar(aprovar: boolean) {
    // Validações para Desconto
    if (aprovacoesNecessarias.find(item => item.tipoAprovacaoId === 1)) {
      if (aprovar && (!percentualAprovar || percentualAprovar <= 0)) {
        toast.error(`O percentual é obrigatório`);
        return;
      }
    }
    // Validações para Parcelas
    else if (aprovacoesNecessarias.find(item => item.tipoAprovacaoId === 2)) {
      if (aprovar) {
        const listaItensFaltantes = informacaoProposta?.parcelas?.filter(
          (item: any) =>
            !item.meioPagamentoId ||
            !item.percentual ||
            !item.dataPrevista ||
            !item.observacao,
        );

        if (listaItensFaltantes && listaItensFaltantes.length > 0) {
          Swal.fire({
            icon: 'error',
            title: 'Ops!',
            html: 'Um ou mais registros da lista estão incompletos. Todos são obrigatórios.',
          });
          return;
        }
      }
    } else if (tipoAprovacao.id === 4) {
      if (aprovar && (!valorMaoObra || valorMaoObra <= 0)) {
        toast.error(`Valor de Mão de Obra é obrigatório`);
        return;
      }
    }

    if (!aprovar) {
      openModalReprovar();
    } else {
      openModalAprovar();
    }
  }
  async function getInformacoesAprovacao() {
    setIsLoading(true);
    const response2 = await api.get(
      `/proposta/versao/${propostaVersao.id}/aprovacao`,
      {},
    );

    const propostaAprovacao = response2.data?.propostaAprovacao ?? [];

    if (propostaAprovacao && propostaAprovacao.length) {
      const lista =
        propostaAprovacao?.map((item: any) => {
          return {
            tipoAprovacaoId: item.tipoAprovacaoId,
          };
        }) ?? [];

      setAprovacoesNecessarias([...lista]);
    }

    if (response2.data?.propostaTipoAprovacao)
      setTipoAprovacao(response2.data?.propostaTipoAprovacao);

    setLogsAprovacao(response2.data?.propostaVersaoLogAprovacao);
    setValorMaximoUsuario(response2.data?.descontoMaximo?.descontoMaximo);
    setIsLoading(false);
  }

  useEffect(() => {
    dadosProposta();
    getInformacoesAprovacao();
  }, []);

  async function handleChange(newObject: iPropostaDados) {
    setInformacaoProposta(newObject);
    // sempre que houver mudanças aqui, vou desabilitar o botão de salvar. O usuário precisa calcular primeiro
  }

  if (!informacaoProposta) return <></>;

  return (
    <>
      <Card className="shadow mt-1 mb-1">
        <CardBody>
          <Row className="ml-0">
            <Col sm="9">
              <h6 className="heading-small text-muted mb-1">
                Aprovação Pendente
                {isLoading && (
                  <CircularProgress
                    className="mt-2 ml-2"
                    color="inherit"
                    size={10}
                  />
                )}
              </h6>
            </Col>
          </Row>
          <hr className="mt-2" />

          <Row
            hidden={
              !aprovacoesNecessarias.find(item => item.tipoAprovacaoId === 1)
            }
          >
            <Col className="mt-2" sm="5">
              <div
                className="float-right"
                style={{
                  textAlign: 'right',
                  paddingTop: '10px',
                }}
              >
                <strong className="mt-2">
                  Percentual desconto para aprovar:
                </strong>
                <br />
                <small>
                  Você pode alterar o percentual de desconto solicitado (
                  {percentualSolicitado}%) para outro valor, que será atualizado
                  na proposta após aprovação.
                </small>
              </div>
            </Col>
            <Col className="mt-2" sm="5">
              <InputGroup className="input-group-alternative text-center">
                <Input
                  type="number"
                  disabled={isLoading}
                  value={String(percentualAprovar)}
                  onChange={event =>
                    setPercentualAprovar(Number(event.target.value))
                  }
                />
                <InputGroupAddon addonType="append">%</InputGroupAddon>
              </InputGroup>
            </Col>
          </Row>

          <Row
            hidden={
              !aprovacoesNecessarias.find(item => item.tipoAprovacaoId === 2)
            }
          >
            <Col sm="12">
              <Parcelas
                propostaVersao={informacaoProposta}
                isModoSimulacao={!isLoading}
                onChange={handleChange}
                isAnalisador={false}
                acessoPrograma={{
                  difal: {
                    temAcesso: false,
                    acessoLimitado: true,
                  },
                  custoFinanceiro: {
                    temAcesso: false,
                    acessoLimitado: true,
                  },
                  comissao: {
                    temAcesso: false,
                    acessoLimitado: true,
                  },
                  taxaFlat: {
                    temAcesso: false,
                    acessoLimitado: true,
                  },
                  variaveisComerciais: {
                    temAcesso: false,
                    acessoLimitado: true,
                  },
                  acessoriaRemota: {
                    temAcesso: false,
                    acessoLimitado: true,
                  },
                }}
              />
            </Col>
          </Row>

          <Row
            hidden={
              !aprovacoesNecessarias.find(item => item.tipoAprovacaoId === 3)
            }
          >
            <Col className="mt-2" sm="12">
              <p>
                Proposta aguarda a aprovação final para que seu status possa ser
                alterado para Aprovado.
              </p>
              <p>
                Ao aprovar, o status será alterado para Aprovado, ou voltará
                para o status original, caso seja reprovado.
              </p>
            </Col>
          </Row>

          <Row hidden={tipoAprovacao.id !== 4}>
            <Col className="mt-2" sm="5">
              <div
                className="float-right"
                style={{
                  textAlign: 'right',
                  paddingTop: '10px',
                }}
              >
                <strong className="mt-2">Valor Mão de Obra Supervisor:</strong>
                <br />
                <small>
                  Você pode alterar o valor (
                  {formatCurrency(
                    propostaVersao?.valorMaoObraSupervisor ?? 0,
                    2,
                  )}
                  ) para outro valor, que será atualizado na proposta após
                  aprovação.
                </small>
              </div>
            </Col>
            <Col className="mt-2" sm="5">
              <InputGroup className="input-group-alternative text-center">
                <InputGroupAddon addonType="append">R$</InputGroupAddon>
                <Input
                  type="number"
                  disabled={isLoading}
                  value={String(valorMaoObra)}
                  onChange={event =>
                    setValorMaoObra(Number(event.target.value))
                  }
                />
              </InputGroup>
            </Col>
          </Row>

          <Row hidden={tipoAprovacao.id !== 5}>
            <Col className="mt-2" sm="12">
              <p>Lista dos materiais que serão excluídos</p>
              <pre>{aprovacaoComplemento}</pre>
            </Col>
          </Row>

          <Row>
            <Col className="mt-4" sm="6" hidden={tipoAprovacao.id === 4}>
              <Button
                className="btn-block"
                color="danger"
                type="button"
                size="sm"
                disabled={isLoading}
                onClick={() => handleAprovarReprovar(false)}
              >
                <FaTimesCircle /> Reprovar
              </Button>
            </Col>
            <Col className="mt-4" sm="6">
              <Button
                className="btn-block"
                color="success"
                type="button"
                size="sm"
                disabled={isLoading}
                onClick={() => handleAprovarReprovar(true)}
              >
                <FaCheckCircle /> Aprovar
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="shadow mt-2 mb-1">
        <CardBody>
          <Row className="ml-0">
            <h6 className="heading-small text-muted mb-1">
              Logs de Aprovação de {tipoAprovacao.descricao}
              {isLoading && (
                <CircularProgress
                  className="mt-2 ml-2"
                  color="inherit"
                  size={10}
                />
              )}
            </h6>
          </Row>
          <hr className="mt-2" />
          <Row>
            <Col sm="12">
              {logsAprovacao.map(item => {
                const dataGeracao = new Intl.DateTimeFormat('pt-BR', {
                  dateStyle: 'long',
                  timeStyle: 'medium',
                }).format(new Date(item.createdAt));

                return (
                  <div className="mt-1">
                    <small className="font-weight-bold">{dataGeracao}:</small>
                    <p className="text-sm my-2">
                      [{item.Usuario.nome}] - {item.descricao}
                    </p>
                  </div>
                );
              })}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
}
